module.exports = __webpack_public_path__ + "img/coinbankC37.f9511290.jpg";